module.exports = __webpack_public_path__ + "img/logo.32dd51ce.png";